module.exports = __webpack_public_path__ + "static/media/ChitChatter.9f468866.png";